module.exports = __webpack_public_path__ + "static/img/8.6b01b4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/8.png
// module id = zWDf
// module chunks = 0